import TableCell from '@mui/material/TableCell';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import TableSortLabel from '@mui/material/TableSortLabel';
import { Column, Order } from '../types';

import styles from '../DataGridTable.module.scss';

type DataGridTableHeadProps = {
  columns: Column[];
  order: Order;
  orderBy: string | null;
  isSortDisabled: boolean;
  onRequestSort: (event: React.MouseEvent<unknown>, property: string) => void;
};

export const DataGridTableHead = ({
  columns,
  order,
  orderBy,
  isSortDisabled,
  onRequestSort,
}: DataGridTableHeadProps) => (
  <TableHead className={styles.thead}>
    <TableRow>
      {columns?.map(headCell => {
        const id = headCell.id;
        const label = headCell.label;
        const alignment = headCell.alignment || 'left';

        const isActive = !isSortDisabled && orderBy === id;
        const isSortable = !isSortDisabled && !headCell.disableSorting;

        return (
          <TableCell
            key={id}
            align={alignment}
            title={label}
            sortDirection={isActive ? order : false}
            sx={{
              cursor: !isSortable ? 'default' : 'pointer',
            }}
          >
            <TableSortLabel
              active={isActive}
              direction={isActive ? order : 'asc'}
              onClick={
                isSortable
                  ? event => onRequestSort(event, headCell.id)
                  : undefined
              }
              aria-disabled={!isSortable}
              sx={{
                pointerEvents: !isSortable ? 'none' : 'auto',
              }}
            >
              {label}
            </TableSortLabel>
          </TableCell>
        );
      })}
    </TableRow>
  </TableHead>
);
